import { api } from '@/core/api/';

const baseApiURL = 'api/servicesatisfactionquestionnaire';

export const getInitFilters = () => api.get(`${baseApiURL}/initfilters`);

export const getServicesByAreaId = (areaId) =>
  api.get(`${baseApiURL}/servicetypes/${areaId}`);

export const getPorters = (academicYearId) =>
  api.get(`${baseApiURL}/porters/${academicYearId}`);

export const getDisciplineList = () =>
  api.get(`${baseApiURL}/getdisciplinelist`);

export const getschool = (academicYearId) =>
  api.get(`${baseApiURL}/getschool/${academicYearId}`);

export const getProviderMunicipalities = (
  academicYearId,
  providerId,
  centerId,
  locationTypeId
) =>
  api.get(`${baseApiURL}/providermunicipalities`, {
    params: {
      academicYearId,
      providerId,
      centerId,
      locationTypeId,
    },
  });

export const getServiceLocations = (
  academicYearId,
  providerId,
  municipalityId,
  locationTypeId
) =>
  api.get(`${baseApiURL}/servicelocations`, {
    params: {
      academicYearId,
      providerId,
      municipalityId,
      locationTypeId,
    },
  });

export const getMunicipalities = (academicYearId, centerId) =>
  api.get(`${baseApiURL}/municipalities/${academicYearId}/${centerId}`);

export const search = (payload) =>
  api.get(`${baseApiURL}/search`, {
    params: {
      ...payload,
    },
  });

export const updateFamiliarQuestionnaireEmail = (payload) =>
  api.put(`${baseApiURL}/updatefamiliarquestionnaireemail`, payload);

export const resendEmail = (payload) =>
  api.post(`${baseApiURL}/resendemail`, payload);

export const getQuestionnaireStatusBarInfo = (payload) =>
  api.get(`${baseApiURL}/questionnairestatusbarinfo`, {
    params: {
      ...payload,
    },
  });

export const cancelQuestionnaire = (payload) =>
  api.post(`${baseApiURL}/cancelquestionnaire`, payload);

export const createQuestionnaireSample = (payload) =>
  api.post(`${baseApiURL}/createquestionnairesample`, payload);

export const getSamplePrevisualization = (payload) =>
  api.get(`${baseApiURL}/getsampleprevisualization`, {
    params: {
      ...payload,
    },
  });

export const restoreSamplePrevisualization = (payload) =>
  api.post(`${baseApiURL}/restoresampleprevisualization`, payload);

export const setStatusForSampleLog = (payload) =>
  api.post(`${baseApiURL}/setstatusforsamplelog`, payload);

export const createSampleDetailsFromPrevisualization = (payload) =>
  api.post(`${baseApiURL}/createsampledetailsfromprevisualization`, payload);
export const validateSampleSelection = (payload) =>
  api.post(`${baseApiURL}/validatesampleselection`, payload);

export const hasSamplePrevisualizationData = (payload) =>
  api.get(`${baseApiURL}/hassampleprevisualizationdata`, {
    params: {
      ...payload,
    },
  });
export const getGroupedSampleExecutionLogs = () =>
  api.get(`${baseApiURL}/getgroupedsampleexecutionlogs`);

export const getSampleLog = (params) =>
  api.get(`${baseApiURL}/getsamplelog`, { params });

export const searchTecnicalAssistanceQuestionnaires = (payload) =>
  api.get(`${baseApiURL}/search-tecnical-assistance`, {
    params: {
      ...payload,
    },
  });
